import { DataType } from 'components/BasicTable/types';

export enum balanceSteps {
	BankAccount = 'BankAccount',
	Currency = 'Currency',
	TransferDetails = 'TransferDetails',
	Complete = 'Complete',
}

export enum digitalBalanceSteps {
	BankAccount = 'BankAccount',
	Currency = 'Currency',
	TransferDetails = 'TransferDetails',
}

export enum balanceStepsStatus {
	NotStarted = 'NotStarted',
	InProgress = 'InProgress',
	Pending = 'Pending',
	Error = 'Error',
	Completed = 'Completed',
}

export const balanceTransStepsPrefix = 'page.balance.add.step';
export const digitalBalanceAddStepsPrefix = 'page.balance.add.digital.step';

export const amountOptions = [
	[0, 1000],
	[1000, 10000],
	[12000, 80000],
	[100000, 500000],
];
export enum TransferType {
	Topping = 'Topping Up the Account',
	Payment = 'Payment',
	PaymentFee = 'PaymentFee',
	Convert = 'Convert',
}

export enum BalanceType {
	Topping = 'Topping Up the Account',
	Withdrawal = 'Withdrawal',
}

export enum BalanceTypeTranslation {
	Topping = 'topping',
	Withdrawal = 'withdrawal',
}

export enum StatusType {
	Pending = 'Pending',
	PendingScheduler = 'PendingScheduler',
	PendingBoSignerReview = 'PendingBoSignerReview',
	Completed = 'Completed',
	Rejected = 'Rejected',
	Failed = 'Failed',
	Deleted = 'Deleted',
	PendingCCTransfer = 'PendingCCTransfer',
}

export type filter = {
	type: object;
	status: object;
	// currency: object;
};

export type BalanceRequest = {
	referenceNumber: string;
	date: string;
	amount: number;
	currencyId: number;
	type: string;
};

export const BalanceRequestTableColumns: { [key: string]: DataType } = {
	referenceNumber: 'string',
	date: 'date',
	amount: 'number',
	balanceType: 'custom',
	//createdBy: 'string',
};

export type Balance = {
	currency: any;
	amount: number;
	updatedAt: Date;
	ilsValue: number;
	symbol: string;
	pendingAmountInNis: number;
	amountInNis: number;
};

export const initialBalance = [{ amount: '0', currencyId: 16 }];

export enum amountType {
	FOR_USE = 'Use',
	PENDING = 'Pending',
}

export const minimumNewBalanceAmount: number = 1;

export enum BalanceDepositType {
	Digital = 'digital',
	Manual = 'manual',
}

export enum DigitalBalanceFeatureState {
	Enabled = 'enabled',
	UserNotAuthorized = 'user_not_authorized',
	AmountOutOfRange = 'amount_out_of_range',
	BankNotSupported = 'bank_not_supported',
	AllBanksTemporarilyUnavailable = 'all_banks_temporarily_unavailable',
	FeatureDisabled = 'feature_not_active',
}
